// removed by extract-text-webpack-plugin
module.exports = {"report":"_3pTQ46-tp7NklggA7YJx6R","icon":"_1wcC4I0yd3xJn6IeWgo6eO"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/reports/styles.css
// module id = 1658
// module chunks = 0